import './applicantSuccessPage.scss';

import { ThemeProvider } from '@mui/material/styles';
import { FormEvent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import heroesCheering from '../../../assets/heroes-cheering.svg';
import { Button } from '../../../components/Button/Button';
import { Header } from '../../../components/Header/Header';
import { NavigationPane } from '../../../components/NavigationPane/NavigationPane';
import { resetStore } from '../../../store/_core/resetStore';
import useApplicantStore from '../../../store/applicantStore/useApplicantStore';
import useCoapplicantStore from '../../../store/coapplicantStore/useCoapplicantStore';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import { useNavigateWithCallback } from '../../../store/routeStore/hooks/useNavigateWithCallback';
import useThemeStore from '../../../store/themeStore/useThemeStore';
import useWorkflowStore from '../../../store/workflowStore/useWorkflowStore';
import { locator } from '../../../testing/e2e-locator/locator';

export function Component(): ReactNode {
  const { createTheme } = useThemeStore();
  const theme = createTheme();
  const navigateWithCallback = useNavigateWithCallback();

  const { t } = useTranslation();
  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const formSubmit = (event: FormEvent): void => {
    event.preventDefault();

    navigateWithCallback(`/dashboard/application/${vehicleId}`, {
      replace: true,
    }).then((): void => {
      resetStore(useApplicantStore);
      resetStore(useCoapplicantStore);
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="page applicant-success-page">
        <Header
          progress={useWorkflowStore(
            (state): number => state.computed.progress,
          )}
          showDrawerToggle
          showLogo
          splitLayout
        />

        <main>
          <figure>
            <img alt={t('imageAlts.heroesCheering')} src={heroesCheering} />
          </figure>
          <form
            data-testid={locator.pages.applicantSuccess.form.root}
            noValidate
            onSubmit={formSubmit}
          >
            <div className="form-content">
              <h1 data-testid={locator.pages.applicantSuccess.form.h1}>
                {t('ApplicantSuccessPage.title')}
              </h1>
              <h2 data-testid={locator.pages.applicantSuccess.form.h2}>
                {t('ApplicantSuccessPage.subtitle')}
              </h2>

              <div style={{ marginBottom: '3rem' }}>
                <Button
                  data-testid={locator.pages.applicantSuccess.form.submitButton}
                  fullWidth
                  submit
                >
                  {t('ApplicantSuccessPage.dashboard')}
                </Button>
              </div>
            </div>
            <footer data-testid={locator.pages.applicantSuccess.footer.root}>
              {t('copyright', { year: new Date().getFullYear() })}
            </footer>
          </form>
        </main>
      </div>

      <NavigationPane withDrawer withUserNameHeader />
    </ThemeProvider>
  );
}

Component.displayName = 'ApplicantSuccessPage';
